import { Koi } from '@ksyos/koi';
import type { Uuid } from '@common/utils/uuid';
import { DeclarationMethod } from '@common/enums/declarationMethod';
import type { ISchemaContainer } from './schemaContainer';
import { CareProductType } from '../enums/careProductType';

export type InsurerServiceDeclarationSettingEditValidated = {
    careProductType: CareProductType | null;
    declarationMethod: DeclarationMethod;
    endDate: Date | null;
    fundingServicePartId: Uuid | null;
    startDate: Date;
};

export type InsurerServiceDeclarationSettingAddValidated = InsurerServiceDeclarationSettingEditValidated & {
    insurerServiceDeclarationRuleId: string;
};

const insurerServiceDeclarationSettingEdit = Koi.object({
    careProductType: Koi.when('declarationMethod', {
        is: Koi.valid(DeclarationMethod.insurerSettings),
        otherwise: Koi.valid(null),
        then: Koi.koi().enum(CareProductType).disallow(null),
    }),
    declarationMethod: Koi.koi().enum(DeclarationMethod).disallow(null),
    endDate: Koi.koi().date().endDate().allow(null),
    fundingServicePartId: Koi.string().uuid().allow(null),
    startDate: Koi.koi().date(),
}).options({ convert: false, presence: 'required' });

export const insurerServiceDeclarationSettingEditSchema: ISchemaContainer<InsurerServiceDeclarationSettingEditValidated> =
    {
        schema: insurerServiceDeclarationSettingEdit,
    };

export const insurerServiceDeclarationSettingAddSchema: ISchemaContainer<InsurerServiceDeclarationSettingAddValidated> =
    {
        schema: insurerServiceDeclarationSettingEdit.concat(
            Koi.object({
                insurerServiceDeclarationRuleId: Koi.string().uuid(),
            }).options({ convert: false, presence: 'required' })
        ),
    };
